// Avatar utility functions for consistent profile picture handling

/**
 * Checks if a string is a valid image URL (not an emoji or short string)
 * @param str - The string to validate
 * @returns true if the string appears to be a valid image URL
 */
export const isValidImageUrl = (str: string | undefined | null): boolean => {
  if (!str) return false;

  // Check if it's a URL (starts with http, https, or /)
  if (str.startsWith('http://') || str.startsWith('https://') || str.startsWith('/')) {
    return true;
  }

  // Check if it's a data URL
  if (str.startsWith('data:image')) {
    return true;
  }

  // If it's very short (likely an emoji), it's not a URL
  if (str.length <= 4) {
    return false;
  }

  return false;
};

/**
 * Get initials from a name string
 * @param name - The name to extract initials from
 * @returns 1-2 character initials
 */
export const getInitials = (name: string): string => {
  if (!name) return 'U';

  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .join('')
    .substring(0, 2);
};
